import { LockingError } from '#common/types';
export class KeyRangeLock {
    keyRangeLocking;
    lockOwner;
    lockType;
    range;
    constructor(keyRangeLocking, lockOwner, lockType, range) {
        this.keyRangeLocking = keyRangeLocking;
        this.lockOwner = lockOwner;
        this.lockType = lockType;
        this.range = range;
    }
    async execute(operation) {
        await this.lockRange();
        try {
            return await operation();
        }
        finally {
            await this.unlockRange();
        }
    }
    async lockRange() {
        const lockRangeParams = {
            range: this.range,
            lockType: this.lockType,
            lockOwner: this.lockOwner,
        };
        const lockParams = {
            lockRanges: [lockRangeParams],
        };
        if (!(await this.keyRangeLocking.lock(lockParams))) {
            throw new LockingError('Failed to lock the required range!');
        }
    }
    async unlockRange() {
        const unlockRangeParams = {
            range: this.range,
            lockOwner: this.lockOwner,
        };
        await this.keyRangeLocking.unlockRanges([unlockRangeParams]);
    }
}
